import { render, staticRenderFns } from "./PremiumReminderDetail.vue?vue&type=template&id=c5e45d6e"
import script from "./PremiumReminderDetail.vue?vue&type=script&lang=js"
export * from "./PremiumReminderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports